export const MFS_FOLDERS_VERSION = "2.0.1";
//# sourceMappingURL=version.js.map